<script setup lang="ts">
  import { computed, useId } from 'vue';
  import { FontIcon } from '../FontIcon';
  import {
    containerClass,
    contrastClass,
    textClass,
    variantClasses,
  } from './Ribbon.css';
  import type { RibbonProps } from './Ribbon.types';
  import { RibbonVariant } from './Ribbon.types';

  const props = withDefaults(defineProps<RibbonProps>(), {
    variant: RibbonVariant.NEUTRAL,
  });

  const uid = useId();
  const resolvedTestId = computed(() => props.testId ?? `ds-ribbon-${uid}`);

  const containerClasses = computed(() => [
    containerClass,
    variantClasses[props.variant],
    { [contrastClass]: !!props.contrast },
  ]);

  const containerStyle = computed(() =>
    props.backgroundColor
      ? { backgroundColor: props.backgroundColor }
      : undefined,
  );
</script>

<template>
  <div
    :class="containerClasses"
    :style="containerStyle"
    :data-testid="resolvedTestId"
  >
    <FontIcon v-if="iconName" :icon-name="iconName" />
    <span :class="textClass" :data-testid="`${resolvedTestId}-text`">
      {{ text }}
    </span>
  </div>
</template>
